export function OutlineSeguimientoIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2723 14.962C12.1923 16.212 10.3023 16.352 9.04226 15.272C7.79226 14.192 7.65226 12.302 8.73226 11.042C8.87226 10.872 9.03226 10.732 9.20226 10.602C10.2523 9.81198 11.7223 9.79198 12.8023 10.602C12.8623 10.642 12.9123 10.692 12.9623 10.732C14.2123 11.812 14.3523 13.702 13.2723 14.962Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0224 17.882L16.4024 15.632C17.5624 13.242 17.0324 10.272 14.9224 8.452C14.8224 8.362 14.7124 8.272 14.6024 8.202C12.4424 6.582 9.50236 6.622 7.40236 8.202C7.06236 8.452 6.74236 8.752 6.45236 9.082C4.29236 11.592 4.57236 15.382 7.08236 17.552C9.18236 19.362 12.1924 19.462 14.3824 17.952L17.0124 20.212C17.5924 20.712 18.4524 20.642 18.9424 20.072L19.1724 19.812C19.6624 19.242 19.5924 18.372 19.0224 17.882Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2723 14.962C12.1923 16.212 10.3023 16.352 9.04226 15.272C7.79226 14.192 7.65226 12.302 8.73226 11.042C8.87226 10.872 9.03226 10.732 9.20226 10.602C10.2523 9.81198 11.7223 9.79198 12.8023 10.602C12.8623 10.642 12.9123 10.692 12.9623 10.732C14.2123 11.812 14.3523 13.702 13.2723 14.962Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5625 5.5625C5.5625 5.5625 5.5025 5.6125 5.4725 5.6325C4.8825 6.1525 3.9925 6.1225 3.4425 5.5625C2.8525 4.9725 2.8525 4.0225 3.4425 3.4425C4.0325 2.8525 4.9825 2.8525 5.5625 3.4425C6.1525 4.0325 6.1525 4.9825 5.5625 5.5625Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5024 6.00195C18.3309 6.00195 19.0024 5.33038 19.0024 4.50195C19.0024 3.67353 18.3309 3.00195 17.5024 3.00195C16.674 3.00195 16.0024 3.67353 16.0024 4.50195C16.0024 5.33038 16.674 6.00195 17.5024 6.00195Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.40266 8.20281L5.47266 5.63281"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0024 9.00281L18.4824 5.63281"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5325 5.63281L14.6025 8.20281"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
